import styled, { useTheme } from 'styled-components';
import useNoticeDetailPageController from '../../1_application/setting/noticeDetailPageController';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import toIDString from '../../lib/util/dateFormatter';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXBack from '../core/components/buttons/lxBack';
import { XCenter } from '../core/components/center';
import LXError from '../core/error/lx_error';
import LXSpinner from '../core/spinner/lx_spinner';
import { LXbody, LXbodyLong, LXh3 } from '../core/texts/lxText';

const ImageContainer = styled.img`
  padding: 30px 0px 0px 0px;
  width: 660px;
`;
export const Divider = styled.div`
  height: 1px;
  background-color: ${(props) => props.theme.colors.grayLine};
`;

const NoticeDetailPage = () => {
  const theme = useTheme();
  const c = useNoticeDetailPageController();

  const buildImages = () => {
    return c.notice.images.map((imageUrl, idx) => (
      <ImageContainer key={idx} src={imageUrl}></ImageContainer>
    ));
  };

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXBack></LXBack>
        <SizedBox height={60}></SizedBox>
        <LXh3>{c.notice.title}</LXh3>
        <SizedBox height={8}></SizedBox>
        <Row>
        <LXbody color={theme.colors.caption}>
          {toIDString(c.notice.createdAt)}
        </LXbody>
        </Row>
        <SizedBox height={20}></SizedBox>
        <Divider></Divider>
        <SizedBox height={10}></SizedBox>
        {buildImages()}
        <SizedBox height={30}></SizedBox>
        <LXbodyLong width={'660px'}>{c.notice.content}</LXbodyLong>
        <SizedBox height={30}></SizedBox>
      </Column>
    </XCenter>
  );
};

export default withAsync({
  child: NoticeDetailPage,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
